/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { memo, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { IWavyGradientProps } from './WavyGradient.types';
import styles from './styles.module.scss';
import { Gradient } from './gradient.js';

export const WavyGradient = memo<IWavyGradientProps>(({ className }) => {
  const [loaded, setLoaded] = useState(false);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const gradient: any = new Gradient();
    gradient.initGradient('#gradient-canvas');

    if (!canvasRef.current) return;
    // Listen for attribute width and height changes with observer
    const observer = new MutationObserver(() => {
      if (!canvasRef.current) return;

      // Get the width and height of the canvas by attribute
      const width = Number(canvasRef.current.getAttribute('width'));
      const height = Number(canvasRef.current.getAttribute('height'));

      if (width > 0 && height > 0) {
        setLoaded(true);
      }
    });
    observer.observe(canvasRef.current, { attributes: true });
  }, [canvasRef]);

  return (
    <div className={classNames({ [styles.container]: true, [`${className}`]: className })}>
      <div
        className={classNames({ [styles.fallbackGradient]: true, [styles.modLoaded]: loaded })}
      />
      <canvas
        ref={canvasRef}
        data-testid="WavyGradient"
        className={classNames({
          [styles.animatedGradient]: true,
        })}
        id="gradient-canvas"
        data-transition-in
      />
    </div>
  );
});

WavyGradient.displayName = 'WavyGradient';

export default WavyGradient;
